/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Colors } from '../../scss/common/style';

interface DisplayQuantitiesProps {
  cuQuantity?: number;
  dpQuantity?: number;
  duQuantity?: number;
  vertical?: boolean;
  white?: boolean;
}

export default function DisplayQuantities({
  cuQuantity = 0,
  dpQuantity = 0,
  duQuantity = 0,
  vertical = false,
  white = false,
}: DisplayQuantitiesProps): JSX.Element {
  return (
    <Container>
      {vertical ? (
        <>
          <Quantity active>{duQuantity ?? 0}</Quantity>
          <br />
          <Quantity>{dpQuantity ?? 0}</Quantity>
          <br />
          <Quantity>{cuQuantity ?? 0}</Quantity>
        </>
      ) : (
        <ContainerHorizontal>
          <Quantity active>{duQuantity ?? 0}</Quantity>/<Quantity>{dpQuantity ?? 0}</Quantity>/
          <Quantity>{cuQuantity ?? 0}</Quantity>
        </ContainerHorizontal>
      )}
    </Container>
  );
}

const Container = styled.span`
  padding: 0 3px;
  width: fit-content;
  height: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContainerHorizontal = styled.span`
  margin: 0 3px;
  padding: 3px 6px;
  background: #e1f6ff;
  border-radius: 3px;
  font-size: 18px;
  font-weight: 500;
`;

const Quantity = styled.span`
  ${({ active }) =>
    active &&
    `
    font-weight: bold;
    color: ${Colors.darkBlue};
  `};
  ${({ white }) =>
    white &&
    `
    color: #fff;  
  `};
`;
